import RetargetingListForm from 'common/pages/retargeting-list/RetargetingListForm'

export const RetargetingListFormAdvertiser = (props) => <RetargetingListForm {...props} />
